import nestedProperty from './nested_property'
import nestedPropertyOr from './nested_property_or'
import lookupCharName from './escape_table'
import * as UsStates from './us_states'
import { notNil, notEmpty, hasValue, hasOneValue } from './property_helpers'
import { downloadViaLinkCreated } from './downloadUrl'

const Utils = {
  nestedProperty,
  nestedPropertyOr,
  lookupCharName,
  UsStates,
  notNil,
  notEmpty,
  hasValue,
  hasOneValue,
  downloadViaLinkCreated
}

export default Utils

export * from './property_helpers'
export { nestedProperty, nestedPropertyOr }
export * from './downloadUrl'
export * from './time'

export const calculatePercentage = function (dividen, divisor, decimals = 1) {
  return parseFloat((((dividen || 0) / (divisor || 0)) * 100).toFixed(decimals)) || 0.0
}
